<template>    
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>						
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Descrição</option>
                                </select>
                            </div>
                            <div class="col-sm-9 col-md-7 col-lg-6">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                            
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Aberta</option>
                                    <option value="1">Finalizada</option>
                                    <option value="2">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i> Consultar</button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstordensproducao"
                                        :rows="lstordensproducao"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4;">Em edição</span>
                                        <span v-else class="badge badge-pill badge-primary" style="background: #5a956a;">Finalizada</span>                                        
                                    </template>
                                    <template slot="slot_totalcusto" slot-scope="item">
                                        <span style="font-weight: 600;">{{ mtdformatavalordecimal(item.row.totalcusto, 2) }}</span>
                                    </template>                                                                        
                                    <template slot="opcoes" slot-scope="item">
										<button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
											<i class="fa fa-navicon"></i>
										</button>                                        
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Itens exibidos
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstordensproducao.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                            </div>                            
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block btn_ajusta_top" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edid">ID interno:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                       maxlength="20" disabled/>
                            </div>
                            <div class="col-sm-12 col-md-4 col-lg-3">
                                <label for="eddescricao">*Nome de referência:</label>
                                <input type="text" v-model="vdescricao" v-bind:disabled="ativadesativa" class="form-control form-control-sm" id="eddescricao" maxlength="50">
                            </div>
                            <div class="col-sm-12 col-md-3 col-lg-3">
                                <span class="lblselect2">*Filial:</span>
                                <select id="cbfilial" data-placeholder="Selecione a filial" v-bind:disabled="ativadesativa" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtinicio">*Data Inicio:</label>
								<div class="input-group">
									<date-picker id="eddtinicio" v-model="vdtinicio" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddttermino">*Data termino:</label>
								<div class="input-group">
									<date-picker id="eddttermino" v-model="vdttermino" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                                                        
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">PRODUTO/INSUMO</div>
                                    <div class="card-body">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidprodutoprod">Item:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoprod" v-model="vcoddigprod" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigprod, 1)" v-on:keyup.13="mtdlocalizarproduto(vcoddigprod, 1)" style="text-transform: uppercase;" v-bind:disabled="ativadesativa">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto(1)" v-bind:disabled="ativadesativa"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-5">
                                                <label for="eddescricaoprodutoprod">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoprod" v-model="vdescricaoprodutoprod" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditemprod">Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemprod" v-model="vqtditemprod" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="ativadesativa"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">Estoque:</span>
                                                <select id="cbestoqueprod" data-placeholder="Selecione o estoque" v-model="videstoqueprod" data-allow-clear="true" style="width:100%;" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>
                                            <div class="col-md-1">
                                                <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdobterformula()" style="margin-top: 20px;" title="Importar fórmula"><i class="fa fa-mail-reply"></i></button>
                                            </div>                                                                                        
                                        </div>
                                    </div>
                                </div>        
                            </div>                                                   
                            <div class="col-md-12" style="margin-top: 15px;">
                                <div class="card">
                                    <div class="card-header card-in text-center" style="padding: 5px;">CORTES</div>
                                    <div class="card-body">
                                        <div v-show="parseInt(opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edidproduto">Item:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidproduto" v-model="vcoddig" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddig, 2)" v-on:keyup.13="mtdlocalizarproduto(vcoddig, 2)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto(2)"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-5 col-lg-4">
                                                <label for="eddescricaoproduto">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoproduto" v-model="vdescricaoproduto" maxlength="100" style="font-weight: bold;" disabled>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtditem">Quantidade:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditem" v-model="vqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">Estoque:</span>
                                                <select id="cbestoque" data-placeholder="Selecione o estoque" v-model="videstoque" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>                                            
                                            <div class="col-md-2">
                                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritem()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table ref="reflstitens"
                                                        :rows="lstitens"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de ordenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                                    
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdmudpreco(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-usd"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)" v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                    <template slot="slot_codigo" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ item.row.coddig }}</span>
                                                    </template>
                                                    <template slot="slot_prcusto" slot-scope="item">
                                                        <span>{{ mtdformatavalordecimal(item.row.prcusto, 2) }}</span>
                                                    </template>                                                    
                                                    <template slot="slot_qtditem" slot-scope="item">
                                                        <span @click.prevent="mtdalterarqtd(item.row, false, 1)"><i class="op-qtd op-qtd-ret fa fa-minus-circle"></i></span>
                                                        <span style="font-weight: 600;">{{ mtdformatavalordecimal(item.row.qtditem , 3)}}</span>
                                                        <span @click.prevent="mtdalterarqtd(item.row, true, 1)"><i class="op-qtd op-qtd-acres fa fa-plus-circle"></i></span>
                                                    </template>
                                                    <template slot="slot_totalcusto" slot-scope="item">
                                                        <span style="font-weight: 600;">{{ mtdformatavalordecimal(item.row.totalcusto, 2) }}</span>
                                                    </template>                                                    
                                                </vue-bootstrap4-table>
                                            </div>                                                                                        
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <ul class="list-group">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                                        <strong>Total do custo</strong>
                                                        <span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(vtotalcusto, 2)}}</span>
                                                    </li>
                                                </ul>
                                            </div>                                            
                                        </div>
                                    </div>
                                </div>        
                            </div>
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Modal para efetivação  -->
        <div class="modal fade" id="mdlefetivacao" tabindex="-1" role="dialog" aria-labelledby="mdlefetivacaotitulo" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 v-if="efetivacao" class="modal-title"><i class="fa fa-check"></i> Efetivação da desossa</h5>
                    <h5 v-else class="modal-title"><i class="fa fa-check"></i> Detalhes da desossa</h5>        
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                <div class="row">
                        <div class="col-md-12 text-center">
                            <div class="alert alert-primary" style="padding: 5px;" role="alert">
                                <span style="color: #666666; font-weight: 600;"><strong>{{eid}}</strong> - {{edescricao}}</span>
                                <template v-if="!efetivacao">
                                    <span v-if="parseInt(esituacao) === 0" class="badge badge-pill badge-primary" style="background: #646dd4; float: right; font-size: 12px;">Em edição</span>
                                    <span v-else class="badge badge-pill badge-primary" style="background: #5a956a; float: right;  font-size: 12px;">Finalizada</span>                                        
                                </template>
                            </div>                                                                
                        </div>    
                        <div class="col-md-12">
                            <div class="alert alert-secondary" style="background-color: #ffffff; padding: 10px;" role="alert">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edidproperda">ID interno:</label>
                                        <input type="text" class="form-control form-control-sm" id="edidproperda" v-bind:value="ecoddig"
                                            maxlength="20" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                        <label for="eddescricaoproperda">Nome de referência:</label>
                                        <input type="text" v-bind:value="edescproduto" class="form-control form-control-sm" id="eddescricaoproperda" maxlength="50" disabled>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edestoqueproperda">Estoque:</label>
                                        <input type="text" v-bind:value="edescestoque" class="form-control form-control-sm" id="edestoqueproperda" maxlength="50" disabled>
                                    </div>                                
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edqtdprevista">Qtd. Prevista:</label>
                                        <money type="text" class="form-control form-control-sm" id="edqtdprevista" v-model="eqtditemprevista" data-bv-group=".group" maxlength="20" style="text-align:right;" disabled></money>
                                     </div>                                
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edqtdproperda">Qtd. Produzida:</label>
                                        <money type="text" class="form-control form-control-sm" id="edqtdproperda" v-model="eqtditem" data-bv-group=".group" maxlength="20" style="text-align:right;" v-bind:disabled="!efetivacao"></money>
                                    </div>                                                                
                                </div>
                            </div>                                                                
                        </div>  
                        <div class="col-md-12">
                            <ul class="nav nav-tabs">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" href="#dvcortes">Cortes</a>
                                </li>
                                <li class="nav-item">
                                    <a class="nav-link" data-toggle="tab" href="#dvperdas">Perdas</a>
                                </li>
                            </ul>
                            <div class="tab-content border-left border-right border-bottom" style="margin-bottom: 15px;">
                                <div class="tab-pane container active" id="dvcortes" style="padding-top: 15px;">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover">
                                                    <thead class="thead-light">
                                                        <tr style="font-weight: 600;">
                                                            <th>Item:</th>
                                                            <th>ID interno:</th>
                                                            <th>Nome de referência:</th> 
                                                            <th>Pr. Custo:</th>
                                                            <th>Qtd:</th>                                        
                                                            <th>Total custo:</th>
                                                            <th>Estoque:</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in elstitens" v-bind:key="index">
                                                            <td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
                                                            <td style="font-weight: 600;">{{ item.coddig }}</td>
                                                            <td>{{ item.descproduto }}</td>
                                                            <td style="text-align: right;">
                                                                {{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}
                                                            </td>                                        
                                                            <td style="text-align: right; font-weight: 600;">
                                                                {{parseFloat(item.qtditem)}}
                                                            </td>
                                                            <td style="text-align: right; font-weight: 600;">
                                                                <span class="text-danger">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                                            </td>                                        
                                                            <td style="font-weight: 200;">{{ item.descestoque }}</td>       
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>      
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane container fade" id="dvperdas" style="padding-top: 10px;">
                                    <div v-show="efetivacao" class="row">
                                        <div class="col-sm-12 col-md-4 col-lg-4">
                                            <span class="lblselect2">Item:</span>
                                            <select id="cbprodutoperda" data-placeholder="Selecione o item" v-model="vidprodutoperda" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div>                                    
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <label for="edqtditemperda">Quantidade:</label>
                                            <money type="text" class="form-control form-control-sm" id="edqtditemperda" v-model="vqtditemperda" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                        </div>
                                        <div class="col-sm-12 col-md-2 col-lg-2">
                                            <span class="lblselect2">Estoque:</span>
                                            <select id="cbestoqueperda" data-placeholder="Selecione o estoque" v-model="videstoqueperda" data-allow-clear="true" style="width:100%;">
                                            </select>
                                        </div> 
                                        <div class="col-sm-4 col-md-2 col-lg-2">
                                            <label for="cbopperda">Definir:</label>
                                            <select name="cbopperda" class="form-control form-control-sm" id="cbopfiltro" v-model="pdefperda" @change="mtdlimpar_listagem()">
                                                <option value="0">Perda</option>
                                                <option value="1">Descarte</option>
                                            </select>
                                        </div> 
                                        <div class="col-md-2">
                                            <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdincluiritemperda()" style="margin-top: 20px;"><i class="fa fa-plus"></i> Incluir</button>
                                        </div>
                                    </div>
                                    <div class="row" style="padding-top: 10px;">
                                        <div class="col-12">
                                            <div class="table-responsive">
                                                <table class="table table-bordered table-sm table-hover">
                                                    <thead class="thead-light">
                                                        <tr style="font-weight: 600;">
                                                            <th v-if="efetivacao" style="width: 50px;"></th>
                                                            <th>Item:</th>
                                                            <th>ID interno:</th>
                                                            <th>Nome de referência:</th> 
                                                            <th>Pr. Custo:</th>
                                                            <th>Qtd:</th>                                        
                                                            <th>Total custo:</th>
                                                            <th>Estoque:</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(item, index) in elstitensperdas" v-bind:key="index">
                                                            <td v-if="efetivacao">
                                                                <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritemperda(item)"><i class="fa fa-trash"></i></button>
                                                            </td>
                                                            <td style="font-weight: 600; width: 50px;">{{ item.item }}</td>
                                                            <td style="font-weight: 600;">{{ item.coddig }}</td>
                                                            <td>{{ item.descproduto }}</td>
                                                            <td style="text-align: right;">
                                                                {{mtdformatavalordecimal(parseFloat(item.prcusto), 2)}}
                                                            </td>                                        
                                                            <td style="text-align: right; font-weight: 600;">
                                                                {{mtdformatavalordecimal(parseFloat(item.qtditem), 3)}}
                                                            </td>
                                                            <td style="text-align: right; font-weight: 600;">
                                                                <span class="text-danger">{{mtdformatavalordecimal(parseFloat(item.totalcusto), 2)}}</span>
                                                            </td>                                        
                                                            <td style="font-weight: 200;">{{ item.descestoque }}</td>       
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>      
                                        </div>                                    
                                    </div>
                                </div>
                            </div>                  
                        </div>
                        <div class="col-md-12">
                            <ul class="list-group">
                                <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                    <span style="font-weight: 600;">Total custo</span>
                                    <span class="badge badge-danger badge-pill text-right bdg-qtd-reg-info">{{mtdformatavalordecimal(parseFloat(etotalcusto), 2)}}</span>
                                </li>
                            </ul>      
                        </div>              
                </div>
                </div>
                <div class="modal-footer">
                    <button v-show="efetivacao" type="button" class="btn btn-primary btn-sm" style="width: 120px;" @click.prevent="mtdconfirmaefetivacao()"><i class="fa fa-check"></i> Efetivar</button>                
                    <button v-if="efetivacao" type="button" class="btn btn-secondary btn-sm" style="width: 120px;" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>                
                    <button v-else type="button" class="btn btn-secondary btn-sm" style="width: 120px;" data-dismiss="modal"><i class="fa fa-close"></i> Sair</button>                
                </div>
                </div>
            </div>
        </div>
        <!-- Modal para seleção da fórmula -->
        <div class="modal fade" id="mdformula">
            <div class="modal-dialog modal-sm modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Selecione uma fórmula</h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>            
                <div class="modal-body">
                    <div class="row">
                        <div class="col-12">
                            <span class="lblselect2">Fórmula:</span>
                            <select id="cbformula" data-placeholder="Selecione o estoque" v-model="vidformulaimportar" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>
                        <div class="col-12">
                            <span class="lblselect2">Estoque:</span>
                            <select id="cbestoqueformula" data-placeholder="Selecione o estoque" v-model="videstoqueformula" data-allow-clear="true" style="width:100%;">
                            </select>
                        </div>                                                                      
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdconfirmaimportaformula()"><i class="fa fa-check"></i> Importar</button>
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                </div>
                
            </div>
            </div>
        </div>
        <!-- Modal do menu da ordem de producao -->
		<div class="modal fade" id="mdmenuordemdesossa">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active"     data-dismiss="modal" style="font-size: 18px;">{{ mtdformatarzeros(opmenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdalterar(opmenu)"><i class="fa fa-edit"></i> EDITAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdexcluir(opmenu)"><i class="fa fa-trash"></i> REMOVER</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdimprimirproducao(opmenu.id)"><i class="fa fa-print"></i> IMPRIMIR</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtdefetivacao(opmenu.id)"><i class="fa fa-check"></i> EFETIVAR</li>                                
								<li class="list-group-item list-group-item-action font-weight-bold" data-dismiss="modal" style="color: #6c757d;" @click.prevent="mtddetalhes(opmenu.id)"><i class="fa fa-info"></i> DETALHES</li>                                								
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
         <!-- Modal atr preço -->
		<div class="modal fade" id="mdpreco">
			<div class="modal-dialog modal-lg modal-dialog-centered">
			<div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">{{ vidprodutoedicao }} - {{ vdescricaoprodutoedicao }}</h5>
                </div>
				<div class="modal-body">
                    <div  id="dvprecos" >
                        <div class="row">
                            <template v-if="parseInt(voptabela) === 2">
                                <div class="col-sm-12 col-md-6 col-lg-6">
                                    <span class="lblselect2">Tabela:</span>
                                    <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                            data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>
                            </template>
                            <template v-else>
                                <div class="col-sm-12 col-md-8 col-lg-8">
                                    <span class="lblselect2">Tabela:</span>
                                    <select id="cbtabelapreco" v-model="vidtabelapreco" v-bind:disabled="habdestab"
                                            data-placeholder="Selecione uma tabela" data-allow-clear="true" style="width:100%;">
                                    </select>
                                </div>
                            </template>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edmrgtabela">Mrg(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edmrgtabela"
                                        v-model="vmrgtabela" v-bind="money"  
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvltabela">Valor:</label>
                                <div class="input-group" style="z-index: 1;">                                                
                                    <money type="text" class="form-control form-control-sm" id="edvltabela"
                                            v-model="vvltabela" v-bind="money" 
                                            data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                    </money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Visualizar imposto sobre valor" @click.prevent="mtdvisualizarimpostovalor()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                    </div>                                                    
                                </div>
                            </div>         
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edcomissaotabela">Comissão(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edcomissaotabela"
                                        v-model="vcomissaotabela" v-bind="money" 
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="eddescontotabela">Qtd. Mínima:</label>
                                <money type="text" class="form-control form-control-sm" id="eddescontotabela"
                                        v-model="vqtdmintabela" v-bind="money" 
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdmintabela">Desconto %:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdmintabela"
                                        v-model="vdescontotabela" v-bind="money" 
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edvldescpromocional">Des. prom(%):</label>
                                <div class="input-group" style="z-index: 1;">
                                    <money type="text" class="form-control form-control-sm" id="edvldescpromocional"
                                        v-model="vvldescpromocional" v-bind="money" v-bind:disabled="ativadesativa"
                                        data-bv-group=".group" style="text-align:right; background: honeydew; color:darkgreen; font-weight:bold;">
                                    </money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Informar o valor para calcular o percentual" @click.prevent="mtdinformarvalordescpromocional()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-dollar"></i></button>
                                    </div>                                                             
                                </div>
                            </div> 
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <label for="edqtdmintabela">Pr. auxiliar($):</label>
                                <money type="text" class="form-control form-control-sm" id="edqtdmintabela" title="Este preço é utilizado apenas para definir o valor de tabela para visualização na impressão/catalogo de produtos"
                                        v-model="vvlvizu" v-bind="money" v-bind:disabled="ativadesativa"
                                        data-bv-group=".group" style="text-align:right;">
                                </money>
                            </div>                                                  
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <button v-if="parseInt(voptabela) === 1" type="button" id="btinctabela" class="btn btn-info btn-sm"
                                        @click.prevent="mtdgravartabela()" 
                                        style="width:100%; margin-top: 21px;"><i class="fa fa-plus-circle"></i>
                                    Incluir
                                </button>
                                <button v-else type="button" id="btalttabela" class="btn btn-secondary btn-sm"
                                        @click.prevent="mtdgravartabela()" v-bind:disabled="ativadesativa"
                                        style="width:100%; margin-top: 21px;"><i class="fa fa-check"></i>
                                    Salvar
                                </button>                                                 
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-2">
                                <button v-if="parseInt(voptabela) === 2" type="button" id="btcancelartabela" class="btn btn-secondary btn-sm"
                                        @click.prevent="mtdcancelartabela()"
                                        style="width:100%; margin-top: 21px;"><i class="fa fa-undo"></i>
                                    Fechar
                                </button>                                                        
                            </div>                                            
                            <div v-if="lstTabelasPrecos.length > 0" class="col-lg-12">
                                <div class="table-responsive">
                                    <table id="tblistatbpro" class="table table-bordered table-sm table-hover" style="margin-top: 10px">
                                        <thead class="thead-light">
                                        <tr>
                                            <th width="280">Tabela:</th>
                                            <th width="100">Valor:</th>
                                            <th width="100">Mrg(%):</th>
                                            <th width="100">Com.(%):</th>
                                            <th width="100">Qtd. Min.:</th>
                                            <th width="100">Pr. aux. ($):</th>
                                            <th width="100">Desc. %:</th>
                                            <th width="100">Desc. Promo:</th>
                                            <th width="35px" style="text-align: center;">Exc:</th>
                                        </tr>
                                        </thead>
                                        <tbody id="lsttabelaspro">
                                            <tr v-for="(tabela, index) in lstTabelasPrecos" v-bind:key="index">
                                                <td width="150px">{{ tabela.desctabela }}</td>
                                                <td width="100px" style="text-align: right; font-weight: bold;">{{
                                                    formatavalores(tabela.prtabela) }}
                                                </td>
                                                <td width="100px" style="text-align: right;">{{
                                                    formatavalores(tabela.mrglucro) }}
                                                </td>
                                                <td width="100px" style="text-align: right;">{{
                                                    formatavalores(tabela.pcomissao) }}
                                                </td>
                                                <td width="100px" style="text-align: right;">{{
                                                    formatavalores(tabela.qtdminima) }}
                                                </td>
                                                <td width="100px" style="text-align: right;">{{
                                                    formatavalores(tabela.vlvisualiza) }}
                                                </td>
                                                <td width="100px" style="text-align: right;">{{
                                                    formatavalores(tabela.desconto) }}
                                                </td>
                                                <td v-if="parseFloat(tabela.vldescpromocional) > 0" width="120px" style="text-align: right; color: #0acf97; font-weight: bold;">
                                                    {{ formatavalores(tabela.vldescpromocional) }}% (${{ formatavalores(parseFloat(tabela.prtabela) - (tabela.prtabela * parseFloat(tabela.vldescpromocional) / 100)) }})
                                                </td>                                                                        
                                                <td v-else width="120px">
                                                </td>
                                                <td width="100px" class="center" style="text-align: center;">
                                                    <a class="btn btn-secondary btn-sm btn-opcrud ajt-btn" href="#"
                                                    v-bind:disabled="ativadesativa"
                                                    @click.prevent="mtdalterartabela(tabela)"><i class="fa fa-edit"></i></a>
                                                    <a class="btn btn-danger btn-sm btn-opcrud ajt-btn" href="#"
                                                    v-bind:disabled="ativadesativa"
                                                    @click.prevent="mtddeletatabela(index)"><i class="fa fa-trash"></i></a>                                                                            
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-md-10">                                                
                            </div>
                            <div v-if="lstTabelasPrecos.length > 0" class="col-md-2">                                                
                                <button type="button" class="btn btn-green btn-sm btn-block" @click.prevent="mtdsalvartabelasdeprecos()">
                                    Salvar preços
                                </button>                                                
                            </div>                                            
                        </div>    
                    </div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Fechar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>
         <!-- Informar o valor para calcular o percentual da margem de desconto promocional -->
         <div class="modal fade" id="mdinformarvalordescpromocional" >
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-percent" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff; font-size: 12px; margin-top: 5px;">Calcular percentual do descto promocional</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-12">
                                <label for="edvalorsemdescpromocional">Valor sem desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorsemdescpromocional" v-model="avalorsemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                            
                            <div class="col-12">
                                <label for="edvalorcomdescpromocional">Valor com desc. promocional:</label>
                                <money type="text" class="form-control form-control-sm" id="edvalorcomdescpromocional" v-model="avalorcomdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" @change.native="mtdcalcularvalordescpromocional()"></money>
                            </div>                             
                            <div class="col-12">
                                <label for="edamargem">Percentual do desconto(%):</label>
                                <money type="text" class="form-control form-control-sm" id="edamargem" v-model="amargemdescpromocional"
                                        v-bind="money" data-bv-group=".group" style="text-align:right;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdaplicarpercentualdescpromocional()" style="width: 100px;"><i class="fa fa-check"></i> Aplicar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div> 
           <!-- Visualiza o imposto sobre o valor -->
        <div class="modal fade" id="mdimpostovalor" tabindex="-1">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-dollar" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Imposto sobre o valor</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row"> 
                            <div class="col-12">
                                <label for="edivalorbase">Valor base:</label>
                                <div class="input-group" style="z-index: 1;">
                                    <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorbase"
                                            v-bind="money" data-bv-group=".group" style="text-align:right;"></money>
                                    <div class="input-group-append" style="height: 31px;">
                                        <button class="btn btn-primary" title="Atualizar cálculo" @click.prevent="mtdcalculavalorimpostoclasse()" style="border-top-left-radius: 0px!important; border-bottom-left-radius: 0px!important;"><i class="fa fa-refresh"></i></button>
                                    </div>                                            
                                </div>
                            </div>
                            <div class="col-12">
                                <span class="lblselect2">Classe:</span>
                                <select id="cbiclasse" data-placeholder="Selecione uma opção"
                                    v-model="iidclasse"
                                    data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                            
                            <div class="col-12">
                                <label for="edivalorimposto">Imposto:</label>
                                <input type="text" class="form-control form-control-sm text-info" id="edivalorimposto"
                                    v-bind:value="mtdformatavalordecimal(parseFloat(ivalorimposto), 2)"
                                    data-bv-group=".group" style="text-align:right;" disabled>
                            </div>                            
                            <div class="col-12">
                                <label for="edivalorbase">Valor com imposto:</label>
                                <money type="text" class="form-control form-control-sm" id="edivalorbase" v-model="ivalorcomimposto"
                                        v-bind="money" data-bv-group=".group" style="text-align:right; font-weight: bold;" disabled></money>
                            </div>                                                                                                                                                                                                                                  
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdselecionavalorbase()" style="width: 100px;"><i class="fa fa-check"></i> Ok</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 100px;"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>                  
    </div>    
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
    import util from '../utilitarios/util.js'

    export default {        
        name: 'cadordensproducao',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos
        },
        data: function() {
            return {
                //menu
                opmenu              : [],
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variáveis do leitor de código de barras

                //variáveis para a consulta de produtos
                vshowprtabela		: false,
                vidtabela           : null,
                tipopropesquisa     : '',             
                
                lstordensproducao  : [],
                pfiltro      : 1,
                pconteudo    : '',
                psituacao    : 2,   
				pfiltroperiodo      : 1,
                pidfilial           : null,
				pdtini       		: util.DataAtual(true),
				pdtfim       		: util.DataAtual(true),				                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,


                //tabelas de preços
                vhabilitaedicaotabelas  : false,

                //variáveis do crud
                origempesq          : 1,
                opcrud              :  0,
                vid                 : '',
                vdescricao          : '',
                vidfilial           : null,
                vdtinicio           : util.DataAtual(),
                vdttermino          : util.DataAtual(),
                vtotalcusto         : 0,
                vcoddigprod         : '',
                vidprodutoprod  	: '',
                vdescricaoprodutoprod: '',                
                vundprodutoprod		: '',
                vqtditemprod        : 1,
                videstoqueprod      : null,
                vfracionadoprod 	: '',  
                vprcustoprod        : 0,
                qtdregs             : 0,  

                //variáveis do calculo do imposto sobre o valor
                ivalorbase              : 0,
                iidclasse               : null,
                iclasse                 : [],
                ivalorimposto           : 0,
                ivalorcomimposto        : 0,   
                
                //variáveis para atruibuir percentual do desconto promocional
                avalorsemdescpromocional : 0,
                avalorcomdescpromocional : 0,
                amargemdescpromocional   : 0,  
                

                //variaveis da tabela de preço nos produtos
                habdestab           : false,
                voptabela           : 1,
                vidtabelapreco      : null,
                lstTabelasPrecos    : [],
                vmrgtabela          : 0,
                vvltabela           : 0,
                vvlnf               : 0,
                vcomissaotabela     : 0,
                vqtdmintabela       : 0,
                vdescontotabela     : 0,   
                vvlvizu             : 0,
                vvldescpromocional  : 0,
                vidprodutoedicao    : 0,
                vdescricaoprodutoedicao: 0,

                //variaveis da desossa
                lstitens            : [],
                vitem               : 0,
                vcoddig             : '',
                vidproduto			: '',
                vdescricaoproduto 	: '',                
                vundproduto			: '',
                vqtditem            : 1,
                videstoque          : null,
                vfracionado			: '',
                vprcusto            : 0,
                vnomearquivo        : '',

                //variaveis efetivacao
                efetivacao          : false,
                eid                 : '',                
                esituacao           : 0,
                edescricao          : '',
                ecoddig             : '',
                edescproduto        : '',
                eqtditem            : 1,
                eqtditemprevista    : 1,
                eidestoque          : 0,
                edescestoque        : '',
                etotalcusto         : 0,
                elstitens           : [],
                elstitensperdas     : [],
                //perdas
                vitemperda          : 0,
                vidprodutoperda     : null,
                vqtditemperda       : 1,
                videstoqueperda     : null,
                vproselecionadoperda: [],
                vprcustoperda       : 0,
                pdefperda           : 0,
                
                //carregar fórmula
                vidformulaimportar  : null,
                vqtdformula         : 1,
                videstoqueformula   : null,
                lstitensformula     : [],


                //variável para habilitação dos campos
                ativadesativa       : true,
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },                
                options: {
                    format          : 'DD/MM/YYYY',
                    useCurrent      : false,
                    locale          : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'DESOSSA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-conf",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod"
                    },
                    {
                        label: "Filial",
                        name: "fantasiafil",
                        initial_sort : true,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Estoque",
                        name: "descestoque",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descestoque"
                    },                    
                    {
                        label: "Estoque",
                        name: "descestoque",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-descestoque"
                    },                    
                    {
                        label: "Início",
                        name: "dtinicio",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtinicio"
                    },{
                        label: "Término",
                        name: "dttermino",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-dtinicio"
                    },
                    {
                        label: "Total Custo",
                        name: "totalcusto",
                        sort: true,
                        slot_name: "slot_totalcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-totalcusto"
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao"
                    },
                    {
                        label: "Efetivação",
                        name: "dtefetivacao",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-finalizacao"
                    },
                    {
                        label: "Usu. efetiva",
                        name: "nomeusu",
                        initial_sort : false,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-nomeusu"
                    }
                ],
                columnsitens: [
                    {
                        label: '',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-item",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_codigo",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Descrição",
                        name: "descproduto",
                        sort: true,
                        slot_name: "slot_descpro",
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    },
                    {
                        label: "Pr. Custo",
                        name: "prcusto",
                        sort: true,
                        slot_name: "slot_prcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-center"
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        slot_name: "slot_qtditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-qtd-item",
                    },
                    {
                        label: "Und",
                        name: "unditem",
                        sort: true,
                        slot_name: "slot_unditem",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left",
                        row_classes: "def-col-und-item",
                    },
                    {
                        label: "Total Custo",
                        name: "totalcusto",
                        sort: true,
                        slot_name: "slot_totalcusto",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-center"
                    },
                    {
                        label: "Estoque",
                        name: "descestoque",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                    }
                ],                             
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    //checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },                 
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
            mtdcalculaprtabela(){
                if (parseFloat(this.vprcusto) > 0){                
                    let vlcustounitario  = parseFloat(this.vvtotalcusto) / parseFloat(this.vqtditemedicao);
                    //let vladd       = parseFloat(this.vmrgtabela) * parseFloat(this.vprcusto)  / 100;
                    //this.vvltabela  = parseFloat(this.vprcusto) + vladd;                
                    let vladd       = parseFloat(this.vmrgtabela) * parseFloat(vlcustounitario)  / 100;
                    this.vvltabela  = parseFloat(vlcustounitario) + vladd;                
                }else{
                    this.vvltabela  = 0;
                }
            },
            mtdcalculamrgtabela(){
                let dif = parseFloat(this.vvltabela) - parseFloat(this.vprcusto);
                if (dif > 0){                    
                    if(parseFloat(this.vprcusto) > 0){
                        let mrg = dif / parseFloat(this.vprcusto) * 100;
                        this.vmrgtabela = mrg;
                    }else{
                        this.vmrgtabela = 0;
                    }
                }else{
                    this.vmrgtabela = 0;
                }                
            },            
            mtdcalculaprvendamedio(){
                if (!this.vcalcularprvendamedio){
                    if (this.lstTabelasPrecos.length > 0){
                        let vsoma = 0;
                        for (let i = 0; i < this.lstTabelasPrecos.length; i++) {
                            vsoma = vsoma + parseFloat(this.lstTabelasPrecos[i]['prtabela']);                       
                        }
                        this.vprvendamedio = vsoma / this.lstTabelasPrecos.length;
                    }else{
                        this.vprvendamedio = 0;
                    }
                }
                let difpr = this.vprvendamedio - this.vprcusto;
                if (parseFloat(this.vprcusto) > 0){
                    this.vmargemprcusto = (difpr / this.vprcusto * 100).toFixed(2);
                }else{
                    this.vmargemprcusto = 0;
                }   
            },
            mtdgravartabela(){
                if (parseInt(this.voptabela) === 1){//inclusão da tabela
                    if (this.vidtabelapreco === null) {
                        util.notif("warning", 'Tabela de preço deve ser informada!');
                        $('#cbtabelapreco').select2('open');
                    }else if (this.vvltabela <= 0) {
                        util.notif("warning", 'Preço de venda deve ser informado!');
                        $('#edvltabela').focus();
                    }else {
                        if (!util.findValInArray(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco)) {
                            let tabelapr = {
                                'idtabela'      : this.vidtabelapreco,
                                'desctabela'    : $('#cbtabelapreco').select2('data')[0]['text'],
                                'mrglucro'      : parseFloat(this.vmrgtabela),
                                'prtabela'      : parseFloat(this.vvltabela).toFixed(2),
                                'vlnf'          : parseFloat(this.vvlnf).toFixed(2),
                                'pcomissao'     : parseFloat(this.vcomissaotabela),
                                'qtdminima'     : parseFloat(this.vqtdmintabela),
                                'vlvisualiza'   : parseFloat(this.vvlvizu),
                                'desconto'      : parseFloat(this.vdescontotabela),
                                'vldescpromocional' : parseFloat(this.vvldescpromocional)
                            };                            
                            this.lstTabelasPrecos.push(tabelapr);
                            this.vidtabelapreco  = null;
                            this.vmrgtabela      = 0;
                            this.vvltabela       = 0;
                            this.vvlnf           = 0;
                            this.vcomissaotabela = 0;
                            this.vqtdmintabela   = 0;
                            this.vvlvizu         = 0;
                            this.vdescontotabela = 0;
                            this.vvldescpromocional = 0;
                            this.voptabela       = 1;
                            this.habdestab       = false;                            
                            $('#cbtabelapreco').val(null).trigger('change');
                            this.mtdcalculaprvendamedio();
                            $('#cbtabelapreco').select2('open');
                        } else {
                            util.notif("warning", 'Tabela de preço já cadastrada!');
                            $('#cbtabelapreco').select2('open');
                        }
                    }
                }else{//alteração da tabela
                    let indt = util.getArrayIndexForKey(this.lstTabelasPrecos, 'idtabela', this.vidtabelapreco);
                    this.lstTabelasPrecos[indt].mrglucro    = parseFloat(this.vmrgtabela);
                    this.lstTabelasPrecos[indt].prtabela    = parseFloat(this.vvltabela).toFixed(2);
                    this.lstTabelasPrecos[indt].vlnf        = parseFloat(this.vvlnf).toFixed(2);
                    this.lstTabelasPrecos[indt].pcomissao   = parseFloat(this.vcomissaotabela);
                    this.lstTabelasPrecos[indt].qtdminima   = parseFloat(this.vqtdmintabela);
                    this.lstTabelasPrecos[indt].vlvisualiza = parseFloat(this.vvlvizu);
                    this.lstTabelasPrecos[indt].desconto    = parseFloat(this.vdescontotabela);
                    this.lstTabelasPrecos[indt].vldescpromocional = parseFloat(this.vvldescpromocional);    
                    this.vidtabelapreco  = null;
                    this.vmrgtabela      = 0;
                    this.vvltabela       = 0;
                    this.vvlnf           = 0;
                    this.vcomissaotabela = 0;
                    this.vqtdmintabela   = 0;
                    this.vdescontotabela = 0;
                    this.vvlvizu         = 0;
                    this.vvldescpromocional = 0;
                    this.voptabela       = 1;
                    this.habdestab       = false;
                    $('#cbtabelapreco').val(null).trigger('change');
                    this.mtdcalculaprvendamedio();
                    $('#cbtabelapreco').select2('open');
                }
            },
            mtdalterartabela(tabela){
                if (!this.ativadesativa) {   
                    this.voptabela  = 2;  
                    this.habdestab  = true;
                    var deftab      = new Option(tabela.desctabela, tabela.idtabela, true, true);
                    $('#cbtabelapreco').append(deftab).trigger('change');
                    this.vmrgtabela         = tabela.mrglucro;
                    this.vvltabela          = tabela.prtabela;
                    this.vvlvizu            = tabela.vlvisualiza;
                    this.vvlnf              = tabela.vlnf;
                    this.vcomissaotabela    = tabela.pcomissao;
                    this.vqtdmintabela      = tabela.qtdminima;
                    this.vdescontotabela    = tabela.desconto;
                    this.vvldescpromocional = tabela.vldescpromocional;
                    $('#edvltabela').focus();
                }
            },
            mtdcancelartabela(){
                this.voptabela          = 1; 
                this.habdestab          = false;
                this.vmrgtabela         = 0;
                this.vvltabela          = 0;
                this.vvlvizu            = 0;
                this.vvlnf              = 0;
                this.vcomissaotabela    = 0;
                this.vqtdmintabela      = 0;
                this.vdescontotabela    = 0;    
                this.vvldescpromocional = 0;            
                $('#cbtabelapreco').val(null).trigger('change');
                $('#cbtabelapreco').select2('open');                  
            },
            mtddeletatabela(index) {
                this.lstTabelasPrecos.splice(index, 1);
                this.mtdcalculaprvendamedio();
            },
            mtdsalvartabelasdeprecos(){
                let vself = this; 
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma alterações da(s) tabela(s) de preço(s) do item?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        let loader = vself.$loading.show();
                        let parametros      = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'salvartabelasprecos'},
                            {parametro: 'idproduto',    valor : vself.vidprodutoedicao},
                            {parametro: 'descricao',    valor : vself.vdescricaoprodutoedicao},
                            {parametro: 'tabelas',      valor : JSON.stringify(vself.lstTabelasPrecos)},
                            {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                            {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                            {parametro: 'codop',        valor : '010Z.010Z.025Z'},
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                        retorno.then(function (response) {
                            loader.hide();
                            $('#mdatualizacoes').modal('hide');	
                            if ($.isNumeric(response.data)){                        
                                util.notif("success", 'Registro processado com sucesso!')
                            }else{
                                let tpret = response.data.substring(0,1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif("warning", response.data.substring(4))
                                        break;
                                    case 'E': default:
                                        util.notif("error", response.data.substring(4))
                                        break;
                                }
                            }
                        }).catch(function (response) {
                            loader.hide();
                            util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                        });  
                    } else {
                        $('#btgravar').focus();
                    }
                });               
            },
            formatavalores:function (val) {
                return util.formatarvalor(val, '');
            },    
            mtdmudpreco(produto){
                this.mtdlocalizarprodutopreco(produto.coddig);
                $('#mdpreco').modal('show');
            },
            mtdmostrarmenu(op){				
                this.opmenu = op;
				$('#mdmenuordemdesossa').modal('show');
            },   
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
            },                     
            mtdformatavalordecimal(valor, digitos){
                return util.formatavalordecimais(valor, digitos);
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},            
            mtddefinial(){
                let vself = this;

				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';
                 
                    //define métodos ao sair dos campos
                $("#edmrgtabela").blur(function(){
                    vself.mtdcalculaprtabela();
                });
                $("#edvltabela").blur(function(){
                    vself.mtdcalculamrgtabela();
                });  

                 //select da tabelela de preços
                 $("#cbtabelapreco").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbtabelasprecos',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidtabelapreco = $("#cbtabelapreco").val();
                    if (vself.vidtabelapreco != null) {
                        let loader      = vself.$loading.show();
                        let parametros  = [
                            {parametro: 'op',           valor : 'listagem'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'filtro',       valor : ' and id='+vself.vidtabelapreco},
                            {parametro: 'limit',        valor : 1},
                            {parametro: 'offset',       valor : 0},
                        ];
                        let retorno          = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadtabelasprecos.php');
                        retorno.then(function (response) {
                            if (parseInt(vself.voptabela) === 1){
                                vself.vmrgtabela = parseFloat(response.data[0].margem); 
                                vself.mtdcalculaprtabela();                           
                            }
                            loader.hide();
                        }).catch(function (response) {
                            console.log(response);
                            loader.hide();
                        });
                    } else {//quando limpa seleção
                        vself.vmrgtabela = 0;
                        vself.vvlvtabela = 0;
                    }
                });
                
                $("#cbiclasse").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbclassesimpostos',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.iidclasse = $("#cbiclasse").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and ci.id='+vself.iidclasse;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 99999999999},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclassesimpostos.php');
                    retorno.then(function (response) {
                        loader.hide();                        
                        vself.iclasse        = response.data[0];
                        vself.iclasse.campos = vself.iclasse.lstcampos;
                        vself.mtdcalculavalorimpostoclasse();

                    }).catch(function (response) {
                        vself.iclasse = [];
                        loader.hide();
                    });

                });                
				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
				});

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and f.codfil='+vself.vidfilial;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'diretoriocertificados', valor : vself.$store.state.configpaths.pathcertificados+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadfiliais.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (response.data.length > 0){
                            var defestpro = new Option(response.data[0].descestoque, response.data[0].idestoque, true, true);
                            $('#cbestoqueprod').append(defestpro).trigger('change');

                            var defest = new Option(response.data[0].descestoque, response.data[0].idestoque, true, true);
                            $('#cbestoque').append(defest).trigger('change');	                                            	                
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });                    
				});                      
				$("#cbestoqueprod").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueprod = $("#cbestoqueprod").val();
				});                
				$("#cbestoque").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoque = $("#cbestoque").val();
				});
                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinaferencia();
                });                 
            
				$("#cbprodutoperda").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'vtprodutosconsumoambos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidprodutoperda = $("#cbprodutoperda").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and p.id='+vself.vidprodutoperda;
                    let parametros  = [
                        {parametro: 'op',               valor : 'listagem'},
                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',           valor : filtro},
                        {parametro: 'limit',            valor : 1},
                        {parametro: 'offset',           valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (response.data.length > 0){
                            vself.vproselecionadoperda = response.data[0];
                            vself.vqtditemperda 
                            for (let item of vself.elstitens) {
                                if (parseInt(item.idproduto) === parseInt(vself.vproselecionadoperda.id)){
                                        vself.vqtditemperda = item.qtditem
                                        vself.vprcustoperda = item.prcusto
                                        break;
                                } 
                            }
                        }else{
                            vself.vproselecionadoperda = [];
                        }
                    }).catch(function (response) {
                        loader.hide();
                    });                                        
				});                             
				$("#cbestoqueperda").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueperda = $("#cbestoqueperda").val();
				});            
				$("#cbformula").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbformulas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidformulaimportar = $("#cbformula").val();
                    let loader      = vself.$loading.show();
                    let filtro      = ' and id='+vself.vidformulaimportar;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadformulas.php');
                    retorno.then(function (response) {
                        loader.hide();
                        vself.lstitensformula = response.data[0].itens;
                    }).catch(function (response) {
                        loader.hide();
                    });                    
				});            
				$("#cbestoqueformula").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbestoques',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.videstoqueformula = $("#cbestoqueformula").val();
				});

                $('#mdpreco').on('shown.bs.modal', function (e) {                    
					vself.mtdlimparedicaoitem();
                }); 
                $('#mdpreco').on('hidden.bs.modal', function (e) {                    
					vself.mtdlimparedicaoitem();
                });     
            },
            mtdlocalizarprodutopreco(coddig){
                let vself           = this;
				if (coddig !== '' && coddig !== null){					
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            let produto = response.data[0];
                                vself.vidprodutoedicao			= produto.id;
                                vself.vdescricaoprodutoedicao 	= produto.descricao;
                                vself.lstTabelasPrecos          = produto.tabelas;
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    if (parseInt(vself.origempesqpro) === 0){
                        vself.mtdlimparedicaoitem();
                    }else if(parseInt(vself.origempesqpro) === 1){

                    }                    
				}
            },
            mtdcalculavalorimpostoclasse(){
                let vself   = this;
                let ret     = util.itemcomimposto(vself.iclasse, parseFloat(vself.ivalorbase), 1, 0, 0);

                vself.ivalorimposto    = ret.totalimpostoitem;
                vself.ivalorcomimposto = ret.vltotalitem;	                
            },
            mtdlimparedicaoitem(){
                //tabelas de preços
                this.vidtabelapreco             = null;
                this.lstTabelasPrecos           = [];
                this.vmrgtabela                 = 0;
                this.vvltabela                  = 0;
                this.vvlnf                      = 0;
                this.vcomissaotabela            = 0;
                this.vqtdmintabela              = 0;
                this.vdescontotabela            = 0; 
                this.vvldescpromocional         = 0;  
                $("#cbtabelapreco").val(null).trigger('change');
            },	
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (parseInt(this.pfiltro) === 0){
                    rfiltro = this.pconteudo === '' ? '' : ' and o.id='+this.pconteudo;
                }else{
                    rfiltro = this.pconteudo === '' ? '' : ' and upper(o.descricao) like upper("'+this.pconteudo+'%")';
                }
				if (this.pidfilial !== null){
					rfiltro = rfiltro + ' and o.idfilial='+this.pidfilial;
				}
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and o.dtinicio between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';                
                }

                if (parseInt(this.psituacao) < 2){
                    rfiltro = rfiltro + ' and o.situacao='+this.psituacao;
                }
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregadesossa(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregadesossa(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                vself.$refs.reflstordensproducao.selected_items = [];//limpa os ítens selecionados na table 
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)}
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                retorno.then(function (response) {
                    vself.lstordensproducao = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstordensproducao = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vid                = '';
                this.vdescricao         = '';                
                this.vidfilial          = this.$store.state.filialpadrao.codfil;
                this.qtdregs            = 0
                this.vdtinicio		    = util.DataAtual();
                this.vdttermino		    = util.DataAtual();
                this.vcoddigprod        = '';
                this.vidprodutoprod  	= '';
                this.vdescricaoprodutoprod= '';
                this.vundprodutoprod	= '';
                this.vqtditemprod       = 1;
                this.videstoqueprod     = null;
                this.vfracionadoprod 	= '';                
                this.vtotalcusto        = 0;
                this.vprcustoprod       = 0;

                this.lstitens           = [];
                this.vitem              = 0;
                this.vidproduto			= '';
                this.vcoddig            = '';
                this.vdescricaoproduto 	= '';
                this.vundproduto		= '';
                this.vprcusto           = 0;
                this.vqtditem           = 1;
                this.videstoque         = null;
                this.vfracionado		= ''; 
                
                $("#cbestoque").val(null).trigger('change');

				if (parseInt(this.opcrud) === 1){
					var deffilial  			= new Option(this.$store.state.filialpadrao.fantasia, this.vidfilial, true, true);
					$('#cbfilial').append(deffilial).trigger('change');	
                }

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {
                        $('#eddescricao').focus();
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 1000);
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvperfil"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.060Z.010Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE DESOSSA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstordensproducao = [];
                this.$refs.reflstordensproducao.selected_items = [];//limpa os ítens selecionados na table                 
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                let qtdregs = 0
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }

                for (let index = 0; index < vself.lstitens.length; index++) {
                    qtdregs = qtdregs + vself.lstitens[index].qtditem;
                }

                if((qtdregs < vself.vqtditemprod)&&(vself.opcrud < 3)){
                    Swal.fire({
                        customClass: {
                            confirmButton: "btn btn-success conf",
                            cancelButton: "btn btn-danger"
                        },
                        title: "Confirmação",
                        text: 'Existe uma diferença entre os valores de cortes e o total da peça, confirma ' + vself.itensbc.item2.titulo + '?',
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Fechar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.conf').prop('disabled', true);
                            vself.mtdregistro();
                        } else {
                            $('#btgravar').focus();
                        }
                    });
                }else{
                    Swal.fire({
                        customClass: {
                            confirmButton: "btn btn-success conf",
                            cancelButton: "btn btn-danger"
                        },
                        title: "Confirmação",
                        text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Fechar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.conf').prop('disabled', true);
                            vself.mtdregistro();
                        } else {
                            $('#btgravar').focus();
                        }
                    });
                }
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and o.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#eddescricao').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('010Z.060Z.020Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        util.notif("warning", 'Desossa já finalizada, impossível realizar esta operação!');
                        return;
                    }                         
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE DESOSSA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('010Z.060Z.030Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    if (parseInt(item.situacao) === 1 ){
                        util.notif("warning", 'Desossa já finalizada, impossível realizar esta operação!');
                        return;
                    }                           
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE DESOSSA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vdescricao             = registro.descricao;
                this.vidprodutoprod         = registro.idproduto;
                this.vdtinicio		        = registro.dtinicio;
                this.vdttermino		        = registro.dttermino;
                this.vcoddigprod            = registro.coddig;
                this.vdescricaoprodutoprod  = registro.descproduto;
                this.vfracionadoprod 	    = registro.fracionado;
                this.lstitens               = registro.itens;
                this.vqtditemprod           = registro.qtditem;
                this.vundprodutoprod	    = registro.und;
                this.vitem                  = this.lstitens[this.lstitens.length - 1].item;
                this.vtotalcusto            = parseFloat(registro.totalcusto);
                this.vidfilial              = registro.idfilial;
                this.videstoqueprod         = registro.idestoque;
                this.vprcustoprod           = registro.prcusto

                var deffilial  = new Option(registro.fantasiafil, this.vidfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');

                var defestoque = new Option(registro.descestoque, this.videstoqueprod, true, true);
                $('#cbestoqueprod').append(defestoque).trigger('change');
            },
            mtdregistro(){
                let vself  = this;
                if (parseInt(vself.vfracionadoprod) === 0){
                    if (!Number.isInteger(vself.vqtdformula)){
                        util.notif("warning", 'Quantidade não pode ser FRACIONADA!');
						$('#edqtditemprod').focus();
                        return;
                    }
                }                
                let loader = vself.$loading.show();
                let registrocrud = {
                    'id'                : this.vid,
                    'descricao'         : this.vdescricao,
                    'idfilial'          : this.vidfilial,
                    'dtinicio'			: this.mtdformatadatagravar(this.vdtinicio),
                    'dttermino'			: this.mtdformatadatagravar(this.vdttermino),                    
                    'idestoque'         : this.videstoqueprod,
                    'idproduto'         : this.vidprodutoprod,
                    'coddig'            : this.vcoddigprod,
                    'qtditem'           : this.vqtditemprod,
                    'prcusto'           : this.vprcustoprod,
                    'totalcusto'        : this.vtotalcusto,
                    'itens'             : this.lstitens
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'rotinacrud'},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.060Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.060Z.020Z' : '010Z.060Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregadesossa(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            },
            mtdlocalizarproduto(coddig, origem){
                var vself   = this;
				if (coddig !== '' && coddig !== null){					
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
                            let produto = response.data[0];
                            if (origem === 2){
                                if (parseInt(produto.tipo) !== 2){
                                    if (parseInt(produto.tipo) === 0){
                                        util.notif("warning", 'Produto comercializavel não pode ser usado como insumo!');
                                        $('#edidproduto').focus();
                                        return;
                                    }
                                }                                
                                vself.vidproduto			= produto.id;
                                vself.vdescricaoproduto 	= produto.descricao;
                                vself.vundproduto			= produto.und;
                                vself.vfracionado			= produto.fracionado;
                                vself.vprcusto              = produto.prcusto;

                                if (vself.lancarauto){
                                    let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);

                                    vself.vitem++;                         

                                    let itemtmp = {
                                        idproduto		    : vself.vidproduto,
                                        descproduto		    : vself.vdescricaoproduto,
                                        coddig			    : vself.vcoddig,
                                        item			    : vself.vitem,
                                        qtditem			    : vself.vqtditem,
                                        unditem			    : vself.vundproduto,
                                        prcusto             : vself.vprcusto
                                    };

                                    if (parseInt(vself.vfracionado) === 0){
                                        if (!Number.isInteger(vself.vqtditem)){
                                            util.notif("warning", 'A quantidade não pode ser fracionada para o produto!');
                                            $('#edqtditem').focus();
                                            return;
                                        }
                                    }                                                

                                    if (indiceitem !== -1){
                                        itemtmp.item = indiceitem;                                   
                                        vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);								
                                    }else{
                                        vself.mtdlancaitem(itemtmp);
                                    }
                                    setTimeout(() => {
                                        vself.vidproduto          = '';
                                        vself.vdescricaoproduto   = '';
                                        vself.vcoddig             = '';
                                        vself.vqtditem            = 1;                                    
                                        $('#edidproduto').focus();                                                                                                                      
                                    }, 200);                                 
                                }else{
                                    vself.$nextTick(function () {
                                        $('#edqtditem').focus();
                                    });
                                }                                
                            }else{
                                if (parseInt(produto.tipo) !== 2){
                                    if (parseInt(produto.tipo) === 1){
                                        util.notif("warning", 'Não é possível fabricar insumos!');
                                        $('#edidproduto').focus();
                                        return;
                                    }                                 
                                }
                                vself.vidprodutoprod		= produto.id;
                                vself.vdescricaoprodutoprod	= produto.descricao;
                                vself.vundprodutoprod		= produto.und;
                                vself.vfracionadoprod		= produto.fracionado;
                                vself.vidprodutoprod		= produto.id;
                                vself.vqtditemprod          = 1;
                                vself.vprcustoprod          = produto.prcusto;
                                vself.$nextTick(function () {
                                    $('#edqtditemprod').focus();
                                });                                 
                            }                         
						}else{
                            util.notif("warning", 'Código informado não cadastrado no sistema!');
                            if (origem === 2){                                 
                                vself.vidproduto			= '';
                                vself.vdescricaoproduto 	= '';
                                vself.vundproduto			= '';
                                vself.vfracionado			= '';
                                vself.vprcusto              = 0;
                                $('#edidproduto').focus();
                            }else{
                                vself.vidprodutoprod		= '';
                                vself.vdescricaoprodutoprod	= '';
                                vself.vundprodutoprod		= '';
                                vself.vfracionadoprod		= '';
                                vself.vprcustoprod          = 0;
                                $('#edidprodutoprod').focus();
                            }
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
                    if(origem === 2){ 
                        vself.vidproduto			= '';
                        vself.vdescricaoproduto 	= '';
                        vself.vundproduto			= '';
                        vself.vfracionado			= '';
                        vself.vprcusto              = 0;
                    }else{
                        vself.vidprodutoprod		= '';
                        vself.vdescricaoprodutoprod	= '';
                        vself.vundprodutoprod		= '';
                        vself.vfracionadoprod		= '';
                        vself.vprcustoprod          =  0;                        
                    }
				}
            },        
            mtdconsultarproduto(origem){
                this.origempesq = origem;
                if (parseInt(origem) === 1){
                    this.tipopropesquisa = '0, 2';
                }else{
                    this.tipopropesquisa = '1, 2';
                }
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdincluiritem(){
                let vself = this;
                if (vself.vcoddig === ''){                    
                    util.notif("warning", 'Informe o código do produto!');
                    $('#edidproduto').focus();
                    return;
                }
                if (parseFloat(vself.vqtditem) <= 0){      
                    util.notif("warning", 'Quantidade inválida!');              
                    $('#edqtditem').focus();
                    return;
                }  
                if (vself.videstoque === null){   
                    util.notif("warning", 'O estoque deve ser informado!');                    
                    $('#cbestoque').select2('open');
                    return;
                }                              
                if (parseInt(vself.vfracionado) === 0){
                    if (!Number.isInteger(vself.vqtditem)){
                        util.notif("warning", 'A quantidade não pode ser fracionada!'); 
						$('#edqtditem').focus();
                        return;
                    }
                }

                let indiceitem = util.getArrayIndexForKey(vself.lstitens, 'idproduto', vself.vidproduto);
                vself.vitem++;

                let itemtmp = {
                    idproduto		    : vself.vidproduto,
                    descproduto		    : vself.vdescricaoproduto,
                    coddig			    : vself.vcoddig,
                    item			    : vself.vitem,
                    qtditem			    : vself.vqtditem,
                    unditem			    : vself.vundproduto,
                    prcusto             : vself.vprcustoprod,
                    idestoque           : vself.videstoque,
                    descestoque		    : $('#cbestoque').select2('data')[0]['text'],
                    totalcusto          : util.arredondaValores( parseFloat(vself.vprcustoprod) * parseFloat(vself.vqtditem), 3, 'round')
                };                
                if (indiceitem !== -1){
                    Swal.fire({
                        customClass: {
                            confirmButton: "btn btn-success conf",
                            cancelButton: "btn btn-danger"
                        },
                        title: "Confirmação",
                        text: 'Produto já lançado na produção. Deseja adicionar a quantidade?',
                        icon: "question",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: "Sim",
                        cancelButtonText: "Fechar"
                    }).then((result) => {
                        if (result.isConfirmed) {
                            $('.conf').prop('disabled', true);
                            itemtmp.item = indiceitem;                                   
                            vself.mtdalterarqtd(itemtmp, true, itemtmp.qtditem);

                            vself.vidproduto          = '';
                            vself.vdescricaoproduto   = '';
                            vself.vcoddig             = '';
                            vself.vqtditem            = 1;
                            vself.vprcusto            = 0;
                            setTimeout(() => {
                                $('#edidproduto').focus();                                                                                                                      
                            }, 500);    
                        } else {
                            vself.vidproduto          = '';
                            vself.vdescricaoproduto   = '';
                            vself.vcoddig             = '';
                            vself.vqtditem            = 1; 
                            vself.vprcusto            = 0;                                            
                            setTimeout(() => {
                                $('#edidproduto').focus();                                                                                                                      
                            }, 500);
                        }
                    });
                            
                }else{
                    vself.mtdlancaitem(itemtmp);
                }                                
            },            
            mtdlancaitem(itemtmp){
                let vself = this;
                vself.vtotalcusto = parseFloat(vself.vtotalcusto) + parseFloat(itemtmp.totalcusto);
                vself.lstitens.push(itemtmp);    
                vself.vidproduto          = '';
                vself.vdescricaoproduto   = '';
                vself.vundproduto         = '';  
                vself.vcoddig             = '';
                vself.vqtditem            = 1;
                vself.vprcusto            = 0;
                $('#edidproduto').focus();                
            },
            mtdexcluiritem(item){
                let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'item', item.item);
                this.vtotalcusto    = parseFloat(this.vtotalcusto) - parseFloat(item.totalcusto);
                this.lstitens.splice(indiceitem, 1);                
            },
            mtdalterarqtd(item, aumentar, qtd){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitens, 'idproduto', item.idproduto);                
                    if (aumentar) {
                        this.lstitens[indiceitem].qtditem   += parseFloat(qtd); 
                        this.lstitens[indiceitem].totalcusto = util.arredondaValores(parseFloat(this.lstitens[indiceitem].qtditem) * parseFloat(this.lstitens[indiceitem].prcusto), 3, 'round'); 
                        this.vtotalcusto = parseFloat(this.vtotalcusto) + parseFloat(parseFloat(qtd) * parseFloat(this.lstitens[indiceitem].prcusto));
                    }else{
                        if (parseFloat(this.lstitens[indiceitem].qtditem) > 1){
                            this.lstitens[indiceitem].qtditem   -= parseFloat(qtd);
                            this.lstitens[indiceitem].totalcusto = util.arredondaValores(parseFloat(this.lstitens[indiceitem].qtditem) * parseFloat(this.lstitens[indiceitem].prcusto), 3, 'round'); 
                            this.vtotalcusto = parseFloat(this.vtotalcusto) - parseFloat(parseFloat(qtd) * parseFloat(this.lstitens[indiceitem].prcusto));
                        }else{
                            return;
                        }
                    }    
                }
            },
            mtdincluiritemperda(){                
                let vself     = this;
                if (vself.vidprodutoperda === null){
                    util.notif("warning", 'Produto deve ser informado!');
                    $('#cbprodutoperda').select2('open');                    
                    return;
                }                 
                if (vself.videstoqueperda === null){
                    util.notif("warning", 'O estoque deve ser informado!');
                    $('#cbestoqueperda').select2('open');                    
                    return;
                }                
                let encontrou = false;
                for (let item of vself.elstitens) {
                   if (parseInt(item.idproduto) === parseInt(vself.vproselecionadoperda.id)){
                        encontrou = true;
                        break;
                   } 
                }
                if (!encontrou){
                    util.notif("warning", 'Produto não encontrado nos cortes!');
                    $('#cbprodutoperda').select2('open');
                }else{
                    let indiceitem = util.getArrayIndexForKey(vself.elstitensperdas, 'idproduto', vself.vproselecionadoperda.id);                    
                    if (indiceitem === -1){
                        vself.vitemperda++;
                        let itemtmp = {
                            idproduto		    : vself.vproselecionadoperda.id,
                            descproduto		    : vself.vproselecionadoperda.descricao,
                            coddig			    : vself.vproselecionadoperda.id,
                            item			    : vself.vitemperda,
                            qtditem			    : vself.vqtditemperda,
                            unditem			    : vself.vproselecionadoperda.und,
                            prcusto             : util.arredondaValores(parseFloat(vself.vprcustoperda), 2, 'round'),
                            idestoque           : vself.videstoqueperda,
                            descestoque		    : $('#cbestoqueperda').select2('data')[0]['text'],
                            totalcusto          : util.arredondaValores( parseFloat(vself.vprcustoperda) * parseFloat(vself.vqtditemperda), 3, 'round')
                        };
                        if(parseInt(vself.pdefperda)===0){
                            vself.etotalcusto = parseFloat(vself.etotalcusto) + parseFloat(itemtmp.totalcusto);
                        }
                        vself.elstitensperdas.push(itemtmp);
                        vself.vidprodutoperda       = null;
                        $("#cbprodutoperda").val(null).trigger('change');
                        vself.vproselecionadoperda  = [];
                        vself.vqtditemperda         = 1;
                        vself.vprcustoperda         = 0;
                        vself.pdefperda             = 0;
                        $("#cbprodutoperda").select2('open');                        
                    }else{
                        util.notif("warning", 'Produto já lançado como perda!');
                        $("#cbprodutoperda").select2('open');
                    }
                }
            },
            mtdexcluiritemperda(item){
                let indiceitem 		= util.getArrayIndexForKey(this.elstitensperdas, 'item', item.item);
                this.etotalcusto    = parseFloat(this.etotalcusto) - parseFloat(item.totalcusto);
                this.elstitensperdas.splice(indiceitem, 1);                
            },
            mtdefetivacao(iddesossa){                
                let vself               = this; 
                $('.nav-tabs a[href="#dvcortes"]').tab('show');
                vself.elstitensperdas   = [];               
                if (!util.opcaousuario('010Z.060Z.040Z', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else{
                    vself.efetivacao        = true;
                    let loader = vself.$loading.show();
                    let filtro      = ' and o.id='+iddesossa;
                    let parametros  = [
                        {parametro: 'op',           valor : 'listagem'},
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'filtro',       valor : filtro},
                        {parametro: 'limit',        valor : 1},
                        {parametro: 'offset',       valor : 0},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                    retorno.then(function (response) {
                        loader.hide();
                        if (parseInt(response.data[0].situacao) === 1){
                            util.notif("warning", 'Desossa já efetivada');
                        }else{
                            vself.eid               = response.data[0].id;
                            vself.esituacao         = response.data[0].situacao;
                            vself.edescricao        = response.data[0].descricao;
                            vself.ecoddig           = response.data[0].coddig;
                            vself.edescproduto      = response.data[0].descproduto;
                            vself.eqtditemprevista  = response.data[0].qtditem;
                            vself.eqtditem          = response.data[0].qtditem;                            
                            vself.eidestoque        = response.data[0].idestoque;
                            vself.edescestoque      = response.data[0].descestoque;                            
                            vself.etotalcusto       = response.data[0].totalcusto;
                            vself.elstitens         = response.data[0].itens;                            
                            $('#mdlefetivacao').modal('show');
                        }
                    }).catch(function (response) {
                        loader.hide();
                        util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                    });                                
                }                            
            },
            mtdconfirmaefetivacao(){
                let vself = this;
                $('.nav-tabs a[href="#dvcortes"]').tab('show');
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'O processo de ajuste do estoque pode demorar alguns minutos. Deseja mesmo continuar com a Efetivação?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        let loader = vself.$loading.show();
                        let parametros          = [
                            {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',               valor : 'efetivar'},
                            {parametro: 'iddesossa',  valor : vself.eid},
                            {parametro: 'qtdproduzida',     valor : vself.eqtditem},
                            {parametro: 'totalcustofinal',  valor : vself.etotalcusto},
                            {parametro: 'itensperda',       valor : JSON.stringify(vself.elstitensperdas)},
                            {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},                                    
                            {parametro: 'idusuario',        valor : vself.$store.state.usuario.id}
                        ];
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if ($.isNumeric(response.data)){                                            
                                util.notif("success", 'Registro processado com sucesso!')
                                $('#mdlefetivacao').modal('hide');
                                vself.efetivacao    = false;
                                vself.pfiltro       = 0;
                                vself.pconteudo     = vself.eid;
                                vself.pqtd_paginas  = 1;
                                vself.mtdcancelaredicao();
                                vself.mtdcarregadesossa(1);
                            }else{                                            
                                let tpret = response.data.substring(0,1);
                                switch (tpret) {
                                    case 'I':
                                        util.notif("warning", response.data.substring(4))
                                        break;
                                    case 'E': default:
                                        util.notif("error", response.data.substring(4))
                                        break;
                                }
                            }
                        }).catch(function (response) {                                        
                            loader.hide();
                            vself.efetivacao = false;
                            util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                            $('#mdlefetivacao').modal('hide');
                        });  
                    } else {
                        $('#btgravar').focus();
                    }
                });             
            },
            mtddetalhes(iddesossa){
                let vself               = this; 
                vself.elstitensperdas   = [];               
                $('.nav-tabs a[href="#dvcortes"]').tab('show');
                vself.efetivacao        = false;
                let loader = vself.$loading.show();
                let filtro      = ' and o.id='+iddesossa;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcaddesossa.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.eid               = response.data[0].id;
                    vself.esituacao         = response.data[0].situacao;
                    vself.edescricao        = response.data[0].descricao;
                    vself.ecoddig           = response.data[0].coddig;
                    vself.edescproduto      = response.data[0].descproduto;
                    vself.eqtditemprevista  = response.data[0].qtditem;                            
                    vself.eqtditem          = response.data[0].qtdproduzida;                            
                    vself.eidestoque        = response.data[0].idestoque;
                    vself.edescestoque      = response.data[0].descestoque;                            
                    vself.etotalcusto       = response.data[0].totalcusto;
                    vself.elstitens         = response.data[0].itens;                            
                    vself.elstitensperdas   = response.data[0].itensperda;
                    $('#mdlefetivacao').modal('show');
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });                                  
            },
			mtdimprimirproducao(iddesossa){				
				window.open(this.$store.state.configpaths.pathcontrole+'rtcaddesossa.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&iddesossa='+iddesossa+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
            mtdobterformula(){
                if (this.vidprodutoprod === ''){
                    util.notif("warning", 'Informe o produto a ser produzido!');
                    $('#edidprodutoprod').focus();                    
                    return;
                }                
                //carregar fórmula
                this.vidformulaimportar  = null;

                this.videstoquefomula   = this.$store.state.filialpadrao.idestoque;                
                var defest  			= new Option(this.$store.state.filialpadrao.descestoque, this.vidfilial, true, true);
				$('#cbestoqueformula').append(defest).trigger('change');	            			

                $("#cbformula").val(null).trigger('change');
                this.vqtdformula        = 1;                
                $('#mdformula').modal('show');
                setTimeout(() => {
                   $('#cbformula').select2('open'); 
                }, 300);
            },
            mtdconfirmaimportaformula(){
                let vself = this;
                if (parseInt(vself.vfracionadoprod) === 0){
                    if (!Number.isInteger(vself.vqtdformula)){
						util.notif("warning", 'Quantidade não pode ser fracionada!');
						$('#edqtdformula').focus();
                        return;
                    }
                }
                if (vself.videstoqueformula === null){
                    util.notif("warning", 'Informe o estoque!');
                    $('#cbestoqueformula').select2('open');                    
                    return;
                }                 
                if (vself.vidformulaimportar === null){
                    util.notif("warning", 'Informe a formula!');
                    $('#cbformula').select2('open');                    
                    return;
                }                
                vself.vtotalcusto   = 0;
                vself.lstitens      = [];
    
                for (let item of vself.lstitensformula) {
                    vself.vtotalcusto   = vself.vtotalcusto + (parseFloat(vself.vprcustoprod) * (parseFloat(item.qtditem) / 100) * parseFloat(vself.vqtditemprod))
                    item.totalcusto     = parseFloat(vself.vprcustoprod) * (parseFloat(item.qtditem) / 100) * parseFloat(vself.vqtditemprod)
                    item.prcusto        = vself.vprcustoprod
                    item.qtditem        = util.arredondaValores( parseFloat(vself.vqtditemprod) * (parseFloat(item.qtditem) / 100), 3,'round');  /// guga checkpoint
                    item.idestoque      = vself.videstoqueformula;
                    item.descestoque    = $('#cbestoqueformula').select2('data')[0]['text'];
                    console.log(item);
                    vself.lstitens.push(item);
                }
                $('#mdformula').modal('hide');
            },
            
            mtdvisualizarimpostovalor(){
                this.ivalorbase              = 0;
                this.iidclasse               = null;
                this.iclasse                 = [];
                this.ivalorimposto           = 0;
                this.ivalorcomimposto        = 0; 
                $('#cbiclasse').val(null).trigger('change');            
                $('#mdimpostovalor').modal('show');
            },
            mtdselecionavalorbase(){
                this.vvltabela = this.ivalorbase;
                this.mtdcalculamrgtabela();
                this.iclasse   = [];
                this.vvlvizu   = this.vvltabela;                
                $('#mdimpostovalor').modal('hide');                
            },
            mtdinformarvalordescpromocional(){
                if (parseFloat(this.vvltabela) > 0){
                    $('#mdinformarvalordescpromocional').modal('show');                
                }
            },
            mtdcalcularvalordescpromocional(){
                let dif = parseFloat(this.avalorsemdescpromocional) - parseFloat(this.avalorcomdescpromocional);
                if (parseFloat(this.avalorsemdescpromocional) > 0){
                    this.amargemdescpromocional = (parseFloat(dif) / parseFloat(this.avalorsemdescpromocional) * 100).toFixed(2);                
                }else{
                    this.amargemdescpromocional = 0;
                }
            },
            mtdaplicarpercentualdescpromocional(){
                if (parseFloat(this.amargemdescpromocional) > 0){
                    this.vvldescpromocional = this.amargemdescpromocional;
                    $('#mdinformarvalordescpromocional').modal('hide');
                }else{
                    util.notif("warning", 'Margem deve ser maior que 0(zero)!');
                    $('#edvalorcomdescpromocional').focus(); 
                }
            }
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('010Z.060Z', vself.$store.state.perfilusuario)) {
                        $('#pnlista').fadeIn(700);
                        vself.mtddefinial();
                        vself.mtdcarregadesossa(vself.pagina_atual);
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou() {
                return this.vdescricao === '' || this.vidfilial === null || this.vidprodutoprod === null ||
                this.vqtditemprod <= 0 || this.videstoque === null || this.vdtinicio === null || 
                this.vdttermino === null || this.lstitens.length === 0;
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            idprodutoretornoprod(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
			selecionaperiodo(){
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
			}
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregadesossa(val);
            },
            idprodutoretorno(val){
                if (val !== null || val !== ''){
                    if (this.origempesq === 2){
                        this.vcoddig = val;
                        this.mtdlocalizarproduto(this.vcoddig, 2);					
                    }else{
                        this.vcoddigprod = val;
                        this.mtdlocalizarproduto(this.vcoddigprod, 1);					
                    }
                }
			}
        }
    }
</script>
<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-opcoes-conf{
        width: 70px !important;
    }
    .def-col-descestoque{
        width: 200px!important;
    }    
    .def-col-qtd-item{
        width: 100px!important;
    }
    .def-col-und-item{
        width: 50px !important;
    }    
    .def-col-dtinicio{
        width: 150px !important;
    }        
    .def-col-situacao{
        width: 100px !important;
    }     
    .def-col-finalizacao{
        width: 150px !important;
    }     
    .badge-item-resultado{
        font-size: 12px !important;
        width : 120px !important;
    }
    .def-col-nomeusu{
        width: 150px !important;
    }
    .def-col-totalcusto{
        width: 120px !important;
    }
   
</style>